export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.base-data': 'Base Data',
  'menu.base-data.project': 'Project Management',
  'menu.base-data.building': 'Building',
  'menu.base-data.house': 'Residential & Commercial',
  'menu.base-data.houseDetail': 'House Detail',
  'menu.base-data.parking': 'Parking',
  'menu.base-data.order-no': 'Order Number Config',
  'menu.base-data.bank-config': 'Bank Configuration',
  'menu.base-data.service-config': 'Service Configuration',
  'menu.base-data.service-config-detail': 'Service Configuration Detail',
  'menu.document': 'File Management',
  'menu.document.template': 'Document Template',
  'menu.document.my-doc': 'My Documents',
  'menu.document.instruction': 'Common Documents',
  'menu.base-data.vehicle': 'Vehicle',
  'menu.base-data.bank': 'Bank',
  'menu.property': 'Property Sales',
  'menu.property.house': 'Residential & Commercial',
  'menu.property.parking': 'Parking Sales',
  'menu.property.sales-overview': 'Sales Overview',
  'menu.property.vehicle': 'Vehicle',
  'menu.property.property-agent': 'Property Agent',
  'menu.rental': 'Manila Rentals',
  'menu.rental.house': 'Rental Houses',
  'menu.rental.parking': 'Rental Parking',
  'menu.rental.collection': 'Asset Income & Expense Registration',
  'menu.rental.fee_record': 'Asset Daily Expenses',
  'menu.person': 'Personnel',
  'menu.person.houseUser': 'House Owner',
  'menu.person.guest': 'Guest Registration',
  'menu.person.decoration': 'Decoration Registration',
  'menu.person.moveout': 'Moveout Registration',
  'menu.info': 'APP Management',
  'menu.info.banner': 'Banner',
  'menu.info.announcement': 'Announcement',
  'menu.info.Announcement': 'System Announcement',
  'menu.info.urgent-notice': 'Urgent Notice',
  'menu.info.community': 'Community Announcement',
  'menu.info.hall_rental': 'Hall Rental',
  'menu.info.document': 'Document',
  'menu.info.contract': 'Contract Document',
  'menu.info.housekeeper': 'Housekeeper',
  'menu.bill': 'Billing',
  'menu.bill.property-fee': 'Property Fee',
  'menu.bill.water-fee': 'Water Fee',
  'menu.bill.electric-fee': 'Electric Fee',
  'menu.bill.net-fee': 'Network Fee',
  'menu.bill.parking-fee': 'Parking Fee',
  'menu.bill.parking-management-fee': 'Parking Management Fee',
  'menu.bill.other': 'Other Fee',
  'menu.service': 'Property Management',
  'menu.service.property-overview': 'Property Overview',
  'menu.service.house': 'House Query',
  'menu.service.service-config': 'Service Configuration',
  'menu.service.open-service': 'Open Service',
  'menu.service.hall-rental': 'Hall Rental',
  'menu.service.msg': 'Payment Notification',
  'menu.service.review': 'Property Pending Review',
  'menu.service.reviewed': 'Property Reviewed',
  'menu.service.property-review': 'Property Pending Review',
  'menu.service.property-reviewed': 'Property Reviewed',
  'menu.service.vehicle': 'Vehicle Management',
  'menu.service.maintenance': 'Maintenance',
  'menu.service.complaint': 'Complaint',

  'menu.sys': 'System',
  'menu.sys.user': 'User',
  'menu.sys.role': 'Role',
  'menu.sys.dict': 'Dictionary',
  'menu.sys.menu': 'Menu',
  'menu.sys.department': 'Department',
  'menu.sys.upload': 'File Upload',
  'menu.sys.manual_handing': 'Manual Handling',
  'menu.repair': 'Repair & Complaint',
  'menu.repair.maintenance': 'Maintenance',
  'menu.repair.complaint': 'Complaint',
  'menu.audit': 'Audit',
  'menu.audit.bill': 'Property Payment',
  'menu.audit.property-review': 'Repayment Pending Review',
  'menu.audit.finance-review': 'Finance Pending Review',
  'menu.audit.finance-reviewed': 'Finance Reviewed',
  'menu.pay': 'Payment',
  'menu.pay.bill': 'Bill Payment',
  'menu.pay.bill-notice': 'Payment Notification',
  'menu.pay.msg': 'Message',
  'menu.notice': 'Message',
  'menu.notice.msg': 'Message',
  'menu.notice.daily-report': 'Daily Report',
  'menu.notice.import-notice': 'Important Notice',
  'menu.finance': 'Finance',
  'menu.finance.audit-overview': 'Finance Audit',
  'menu.finance.project': 'Project Management',
  'menu.finance.bank': 'Bank Management',
  'menu.finance.bank-statement': 'Bank Statement',
  'menu.finance.expenses': 'Financial Flow',
  'menu.finance.fin-reporting': 'Financial Reporting',
  'menu.finance.eng-apply': 'Engineering Application',
  'menu.finance.pricing_review': 'Finance Pricing Review',
  'menu.finance.budget-request': 'Budget Request',
  'menu.finance.mortgage-pay': 'Mortgage Repayment',
  'menu.finance.car-pay': 'Parking Space Repayment',
  'menu.finance.finance-reconciliation': 'Financial Reconciliation',
  'menu.finance.financial-report': 'Financial Report',
  'menu.finance.daily-report': 'Reconciliation Report',
  'menu.finance.monthly-report': 'Monthly Report',
  'menu.search': 'Search',
  'menu.search.house': 'House Search',
  'menu.search.parking': 'Parking Query',
  'menu.search.search-parking': 'Parking Query',
  'menu.search.property-reviewed': 'Repayment Query',
  'menu.search.mortgage-statistics': 'Mortgage Statistics',
  'menu.search.finance-search': 'Finance Query',
  'menu.search.user-search': 'User Query',
  'menu.search.data-statistics': 'Data Statistics',
};
